import {
  Icon,
  MenuItem,
  MenuItemProps as BaseMenuItemProps,
  Spinner,
} from "@chakra-ui/react";
import { MdArchive, MdRestore } from "react-icons/md";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";

type CommonProps = { isArchive: boolean; labelSuffix?: string };

type IconButtonProps = Partial<TooltipIconButtonProps> & CommonProps;

export default function ArchiveRestoreIconButton({
  isArchive,
  labelSuffix,
  ...rest
}: IconButtonProps) {
  return (
    <TooltipIconButton
      label={`${isArchive ? "Archive" : "Unarchive"}${
        labelSuffix ? ` ${labelSuffix}` : ""
      }`}
      icon={<Icon as={isArchive ? MdArchive : MdRestore} />}
      color="gray.600"
      {...rest}
    />
  );
}

type MenuItemProps = Partial<BaseMenuItemProps> &
  CommonProps & { isLoading?: boolean };

export function ArchiveRestoreMenuItem({
  isArchive,
  labelSuffix,
  isDisabled,
  isLoading,
  ...rest
}: MenuItemProps) {
  return (
    <MenuItem
      icon={
        isLoading ? (
          <Spinner size="xs" />
        ) : (
          <Icon as={isArchive ? MdArchive : MdRestore} />
        )
      }
      isDisabled={isDisabled || isLoading}
      {...rest}
    >
      {isArchive ? "Archive" : "Unarchive"}
      {labelSuffix ? ` ${labelSuffix}` : ""}
    </MenuItem>
  );
}
